/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RerunTestRequest } from '../../models/rerun-test-request';

export interface ApiAdminApiTestsIdRerunPost$Params {
  id: string;
      body?: RerunTestRequest
}

export function apiAdminApiTestsIdRerunPost(http: HttpClient, rootUrl: string, params: ApiAdminApiTestsIdRerunPost$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiAdminApiTestsIdRerunPost.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as HealthFindrStrictHttpResponse<void>;
    })
  );
}

apiAdminApiTestsIdRerunPost.PATH = '/api/Admin/ApiTests/{id}/Rerun';
